export const MobileScreenQuery = '(max-width: 575px)';
